var o = Object.defineProperty;
var p = (c, e, t) => e in c ? o(c, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : c[e] = t;
var s = (c, e, t) => (p(c, typeof e != "symbol" ? e + "" : e, t), t);
import { createApp as d } from "vue";
import m from "./ApIndicator.vue3.js";
const n = class n {
  open(e = {}) {
    if (!n.instance) {
      const t = document.createElement("div"), a = typeof e == "string" ? e : e.text || "", r = e.spinnerType || "Snake";
      n.instance = d(m, { text: a, spinnerType: r }).mount(t), document.body.appendChild(n.instance.$el);
    }
    return n.instance.show(), n.instance;
  }
  close() {
    n.instance && n.instance.hide();
  }
};
s(n, "instance");
let i = n;
const y = new i();
export {
  y as default
};
